import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { RewardReferralRole } from '../../../models/RewardStore';
import { JoyajoyImage, JoyajoyImageFile } from '../JoyajoyImage';

import styles from './WebStoreProductCard.module.css';

export type WebStoreProductCardProps = {
  width?: number;
  height?: number;
  backgroundColor?: string;
  image: JoyajoyImageFile;
  productName: string;
  normalPrice: string | undefined;
  originalPrice: string | undefined;
  description: string;
  referralReward: string | undefined;
  rewardReferralRole: RewardReferralRole | undefined;
  withShareButton?: boolean;
  withPurchasedBadge?: boolean;
  onClickShare?: () => void;
  onClickCard: () => void;
};

export const WebStoreProductCard = memo((props: WebStoreProductCardProps) => {
  const { t } = useTranslation();

  const {
    width,
    height,
    backgroundColor,
    image,
    productName,
    normalPrice,
    originalPrice,
    description,
    // referralReward,
    // rewardReferralRole,
    withShareButton = false,
    withPurchasedBadge = false,
    onClickShare,
    onClickCard,
  } = props;

  return (
    <div
      className={styles.productCard}
      onClick={onClickCard}
      style={{ width, height, backgroundColor }}
    >
      <div className={styles.productImageContainer}>
        <JoyajoyImage {...image} className={styles.productImage} />
        {withPurchasedBadge && (
          <div className={styles.purchasedBadge}>
            <p className={styles.purchasedBadgeText}>{t('Purchased')}</p>
          </div>
        )}
      </div>
      <div className={styles.productContent}>
        <p className={styles.productTitle}>{productName}</p>
        <div className={styles.priceRow}>
          {normalPrice !== undefined && (
            <span className={styles.normalPrice}>{normalPrice}</span>
          )}
          {originalPrice !== undefined && (
            <span className={styles.originalPrice}>{originalPrice}</span>
          )}
        </div>
        <div className={styles.description}>{description}</div>
        {withShareButton && onClickShare && (
          <button
            className={styles.shareButton}
            onClick={(event) => {
              onClickShare();
              event.stopPropagation();
            }}
          >
            {t('Share & Refer')}
          </button>
        )}

        {/* {referralReward !== undefined && (
          <div className={styles.referralReward}>
            {t('Referral Reward:')}
            {(!rewardReferralRole ||
              rewardReferralRole === RewardReferralRole.Customer) && (
              <img
                src={Icons[IconType.Credit]}
                className={styles.smallJoyCashIcon}
              />
            )}
            {referralReward}
          </div>
        )} */}
      </div>
    </div>
  );
});
